// extracted by mini-css-extract-plugin
export default {"clockStyle":"clockIconStyle_clockStyle__mTma0"};